import React from 'react';
import styled from 'styled-components';
import ReactTooltip from 'react-tooltip';
import PropTypes from 'prop-types';

const TooltipWrapper = styled(ReactTooltip)`
    width: ${({ width }) => width};
    padding: ${({ padding }) => padding};

    &.type-dark.place-bottom {
        font-weight: 600;
        padding: 12px;
        margin-top: 8px;
        background-color: #535454;
        border-radius: 5px;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.25);
        max-width: 180px;
        box-sizing: border-box;
        word-break: break-word;
    }
    &.__react_component_tooltip.type-dark.place-bottom:after {
        border: none;
    }
`;

const TooltipText = styled.span`
    line-height: ${({ textLineHeight }) => textLineHeight};

    font-weight: 600;
    position: relative;
    bottom: 2px;
`;

const Tooltip = ({ children, text, id, disableTooltip, place, width, padding, textLineHeight }) => (
    <div data-test-id="tooltip-container" data-tip data-for={id}>
        {children}
        <TooltipWrapper multiline disable={disableTooltip} id={id} place={place} width={width} padding={padding} effect="solid">
            <TooltipText data-test-id="tooltip-text" textLineHeight={textLineHeight}>{text}</TooltipText>
        </TooltipWrapper>
    </div>
);

Tooltip.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
    text: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    disableTooltip: PropTypes.bool,
    place: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    padding: PropTypes.string,
    textLineHeight: PropTypes.string,
};

Tooltip.defaultProps = {
    disableTooltip: false,
    place: 'bottom',
    width: '180px',
    padding: '8px 21px',
    textLineHeight: 'normal',
};

export default Tooltip;
